<template>
  <vx-card v-if="permissions" no-shadow>
    <vs-prompt
      :title="(isPermissionUpdate ? 'Update' : 'Add') + ' permission'"
      @cancel="val = ''"
      @accept="acceptAddPermissionPrompt"
      @close="closeAddPermissionPrompt"
      :active.sync="addPermissionPrompt"
    >
      <div>
        <div class="vx-row mb-6">
          <vs-button
            @click="deletePermission"
            v-if="isPermissionUpdate"
            class="ml-4"
            color="danger"
            >Delete</vs-button
          >
          <div class="vx-col sm:w-5/5 w-full">
            <vs-input
              :disabled="isPermissionUpdate"
              label="Enter unique permission identifier eg. vp.ap_addContent"
              placeholder="Identifier"
              v-on:keypress="isAllowedInput($event)"
              v-model="newPermId"
              class="mt-5 w-full"
              name="item-name"
            />
          </div>
          <div class="vx-col sm:w-5/5 w-full">
            <vs-input
              placeholder="Service"
              v-model="newPermService"
              class="mt-5 w-full"
              name="item-name"
            />
          </div>
          <div class="vx-col sm:w-5/5 w-full">
            <vs-input
              placeholder="Group"
              v-model="newPermGroup"
              class="mt-5 w-full"
              name="item-name"
            />
          </div>
          <div class="vx-col sm:w-5/5 w-full">
            <vs-input
              placeholder="Title"
              v-model="newPermTitle"
              class="mt-5 w-full"
              name="item-name"
            />
          </div>
          <div class="vx-col sm:w-5/5 w-full">
            <vs-input
              placeholder="Description"
              v-model="newPermDescription"
              class="mt-5 w-full"
              name="item-name"
            />
          </div>
          <div class="vx-col mt-5 sm:w-5/5 w-full">
            <label for="">Is permission limited to allowed entity?</label>
            <vs-switch v-model="newPermEntitySpecific" />
          </div>
        </div>
      </div>
    </vs-prompt>
    <h2 class="mb-6">Permissions</h2>
    <div class="flex flex-wrap-reverse items-center data-list-btn-container">
      <div
        @click="addPermissionPrompt = true"
        v-if="hasPermission('life.admin.roles.permissions.edit')"
        class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
      >
        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">Add permission</span>
      </div>
    </div>

    <vs-collapse type="margin">
      <vs-collapse-item v-for="(service, idxS) in getServices" :key="idxS">
        <div slot="header">
          <span>{{ service.service }}</span>
          <vs-chip
            color="primary"
            style="margin-right: 15px; float: right"
            class="product-order-status"
            >{{
              numPermissionsByService(service.service)
            }}
            permission(s)</vs-chip
          >
        </div>
        <vs-list
          v-for="(group, idxG) in getGroupsByService(service.service)"
          :key="idxG"
        >
          <vs-list-header
            icon="supervisor_account"
            :title="group.group"
          ></vs-list-header>
          <vs-list-item
            :icon="perm.entitySpecific ? 'verified_user' : 'public'"
            @click.native="editPermission(perm)"
            v-for="(perm, idxP) in getPermissionsInGroup(
              group.group,
              group.service
            )"
            :key="idxP"
            :title="perm.title"
            :subtitle="perm.description + ' (' + perm.id + ')'"
          >
          </vs-list-item>
        </vs-list>
      </vs-collapse-item>
    </vs-collapse>
  </vx-card>
</template>

<script>
import _ from "lodash";

export default {
  components: {},
  props: {
    surveyType: String,
  },
  data() {
    return {
      newPermEntitySpecific: false,
      addPermissionPrompt: false,
      permissions: null,
      newPermId: "",
      newPermService: "",
      newPermGroup: "",
      newPermTitle: "",
      newPermDescription: "",
      isPermissionUpdate: false,
    };
  },
  computed: {
    getServices() {
      return _.uniqBy(this.permissions, (e) => e.service);
    },
  },
  methods: {
    editPermission(perm) {
      if (
        localStorage.getItem("rekomAccountId") !==
        "5514ae2d-75f5-41a2-9445-beca5492577c"
      )
        return;
      console.log("Permission details", perm);
      this.isPermissionUpdate = true;
      this.newPermId = perm.id;
      this.newPermService = perm.service;
      this.newPermGroup = perm.group;
      this.newPermTitle = perm.title;
      this.newPermDescription = perm.description;
      this.newPermEntitySpecific = perm.entitySpecific;
      this.addPermissionPrompt = true;
      /* this.$router.push({
        name: "admin-permission",
        params: { id: perm.id },
      }); */
    },
    isAllowedInput(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-z_.]+$/.test(char)) return true;
      else e.preventDefault();
    },
    numPermissionsByService(service) {
      return this.permissions.filter((e) => e.service === service).length;
    },
    getGroupsByService(service) {
      return _.uniqBy(
        this.permissions.filter((e) => e.service === service),
        (e) => e.group
      );
    },
    getPermissionsInGroup(group, service) {
      return this.permissions.filter(
        (p) => p.group === group && p.service === service
      );
    },
    getPermissions: function () {
      this.$vs.loading();

      const url = process.env.VUE_APP_API + "/Idam/Permissions";

      this.$http
        .get(url)
        .then((resp) => {
          console.log(resp.data);
          this.permissions = resp.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    closeAddPermissionPrompt() {
      this.isPermissionUpdate = false;
    },
    acceptAddPermissionPrompt() {
      if (!this.isPermissionUpdate) {
        this.addPermission();
      } else {
        this.updatePermission();
      }
      this.isPermissionUpdate = false;
    },
    updatePermission() {
      this.$vs.loading();
      const payload = {
        id: this.newPermId,
        service: this.newPermService,
        group: this.newPermGroup,
        title: this.newPermTitle,
        description: this.newPermDescription,
        entitySpecific: this.newPermEntitySpecific,
      };

      const url = process.env.VUE_APP_API + "/Idam/Permissions";
      this.$http
        .put(url, payload)
        .then((resp) => {
          console.log(resp.data);

          if (resp.data.success === true) {
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: "Permission updated",
            });

            this.getPermissions();
          } else {
            console.log(resp.data.error);

            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: "Could not update permission: " + resp.data.error,
            });
          }
        })
        .catch((err) => {
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not update permission: " + err,
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    addPermission() {
      this.$vs.loading();
      const payload = {
        id: this.newPermId,
        service: this.newPermService,
        group: this.newPermGroup,
        title: this.newPermTitle,
        description: this.newPermDescription,
        entitySpecific: this.newPermEntitySpecific,
      };

      const url = process.env.VUE_APP_API + "/Idam/Permissions";
      this.$http
        .post(url, payload)
        .then((resp) => {
          console.log(resp.data);

          if (resp.data.success === true) {
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: "Permission added",
            });

            this.getPermissions();
          } else {
            console.log(resp.data.error);

            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: "Could not add permission: " + resp.data.error,
            });
          }
        })
        .catch((err) => {
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not add permission: " + err,
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    deletePermission() {
      this.$vs.loading();
      this.isPermissionUpdate = false;
      this.addPermissionPrompt = false;

      const url =
        process.env.VUE_APP_API + "/Idam/Permissions/" + this.newPermId;
      this.$http
        .delete(url)
        .then((resp) => {
          console.log(resp.data);

          if (resp.data.success === true) {
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: "Permission deleted",
            });

            this.getPermissions();
          } else {
            console.log(resp.data.error);

            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: "Could not delete permission: " + resp.data.error,
            });
          }
        })
        .catch((err) => {
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not delete permission: " + err,
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
  },
  created() {
    this.getPermissions();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">
.vs-collapse-item--header {
  font-weight: 700;
  font-size: 20;
}
.list-titles:nth-child(1) .vs-list--title {
  font-weight: 500;
  font-size: 17px;
  color: #666;
}
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

.con-vs-dialog .vs-dialog {
  max-width: 600px;
}
.questionDisabled {
  opacity: 0.5;
}
</style>
